import { Article, RequiredArticle } from '../../../../interfaces/Article';
import { articleService } from '../../../../services/articleService';
import { Configuration } from '../../../../interfaces/Configuration';
import { Slot } from '../../../../interfaces/Slot';

export interface ArticleReplacement {
  oldArticle: Article;
  newArticle: Article;
  newSlots: Slot[];
  newRequiredConnectArticle: RequiredArticle;
}

export const loadRootDependentArticles = async (
  configuration: Configuration,
  newRootArticle: Article,
  oldArticle: Article
): Promise<ArticleReplacement[]> => {
  return await Promise.all(
    configuration.articles
      .filter(article => article.definition.dependsOnRootSize)
      .map(async article => {
        const [newArticle, newSlots] = await articleService.getArticleDependentOnRoot(
          article.number,
          newRootArticle.number
        );
        const oldRequiredConnectArticleId = oldArticle.requiredConnectArticleId;
        const slot = configuration.getAttachedSlot(article.id);
        let newRequiredConnectArticle;
        if (oldRequiredConnectArticleId) {
          const newRequiredConnectArticleResponse = await articleService.getRequiredConnectArticle(
            newArticle.number,
            slot
          );
          if (!(newRequiredConnectArticleResponse instanceof Error)) {
            newArticle.requiredConnectArticleId = newRequiredConnectArticleResponse.id;
            newRequiredConnectArticle = newRequiredConnectArticleResponse;
          }
        }
        return {
          newArticle,
          newSlots,
          oldArticle: article,
          newRequiredConnectArticle
        };
      })
  );
};
